import axios from "axios";
const axiosInstance = axios.create({
  // baseURL: "https://api.dhoorbin.com",
  baseURL: "https://api.dhoorbin.com",
});

export default axiosInstance;
